export const downloadFile = (fileName: string, fileObject: any, extension: string = "zip") => {
  const blob = new Blob([fileObject]);
  const url = window.URL.createObjectURL(blob);
  const a: HTMLAnchorElement = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  a.href = url;
  if (extension === "zip" && fileName.includes(".zip")) {
    a.download = fileName;
  } else {
    a.download = `${fileName}.${extension}`;
  }
  a.click();
  window.URL.revokeObjectURL(url);
  a.parentNode!.removeChild(a);
};
